"use client";
import Script from 'next/script'
import "@/app/style/global.scss";
import { LANGCODE_CT, LANGCODE_EN, LanguageProvider } from './utils/LanguageContext';
import { useParams, usePathname } from 'next/navigation';
import { useEffect } from 'react';
import dayJS from 'dayjs';
import { getAssetPrefix } from "@/app/utils/Common";
import DataDogRumInit from './utils/DataDogConfig';

export default function RootLayout({
  children,
}: Readonly<{
  children: React.ReactNode;
}>) {
  const { language } = useParams();
  const paths = usePathname().split("/");
  const assetPrefix = getAssetPrefix();
  return (
    <LanguageProvider>
      <>
      <head>
        {language === "zh-hk" ? (
          <link
            href="https://fonts.googleapis.com/css2?family=Noto+Sans+HK:wght@300;400;500;700&display=swap"
            rel="stylesheet"
          ></link>
        ) : (<link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans:ital,wght@0,100..900;1,100..900&display=swap"
          rel="stylesheet"
        ></link>)}
        <DataDogRumInit />
        <Script src={`${assetPrefix}/config/globalConfig.js`} strategy="beforeInteractive" />
        <Script src={`${assetPrefix}/js/wa/wa_handler.js`} strategy="beforeInteractive" />
        <Script src={`${assetPrefix}/js/GBgdpr.js`} strategy="beforeInteractive" />
        <Script src={`${assetPrefix}/js/utils.js`} data-asset-prefix={assetPrefix} strategy="beforeInteractive" /> 
      </head>
      <body className={language === "en-us" ? "fontFamilyEN" : "fontFamilyHK"}
        style={{
          '--url-swiper-before': `url(${assetPrefix}/swiper_before.svg)`,
          '--url-swiper-next': `url(${assetPrefix}/swiper_next.svg)`,
          '--url-seo-bg': `url(${assetPrefix}/images/seo_bg.gif)`,
          '--url-seo-div': `url(${assetPrefix}/images/seo_stroke.gif)`,
          '--url-ewin': `url(${assetPrefix}/commonImg/arrow_1.gif)`,
          '--url-headernav-main': `url(${assetPrefix}/headernav/nav-bg.jpg)`,
          '--url-headernav-sub': `url(${assetPrefix}/headernav/subnav_bg.gif)`,
          '--url-headernav-arrow': `url(${assetPrefix}/headernav/nav_arrow.gif)`,
          '--url-next-btn': `url(${assetPrefix}/nextdayrace_bg.png)`,
          '--url-photo-arrow': `url(${assetPrefix}/photos_arrow.svg)`,
          '--url-bg': `url(${assetPrefix}/commonImg/bg.gif)`,
          '--url-dash': `url(${assetPrefix}/images/dash.gif)`,
          '--url-speedpro-arrow': `url(${assetPrefix}/speedpro/arrow.png)`,
          '--url-speedpro-uparrow': `url(${assetPrefix}/speedpro/up_arrow.png)`,
          '--url-speedpro-downarrow': `url(${assetPrefix}/speedpro/down_arrow.png)`,
          '--url-speedpro-formGuide1up': `url(${assetPrefix}/speedpro/formGuide_1up.gif)`,
          '--url-speedpro-formGuide2up': `url(${assetPrefix}/speedpro/formGuide_2up.gif)`,
          '--url-speedpro-formGuide3up': `url(${assetPrefix}/speedpro/formGuide_3up.gif)`,
          '--url-speedpro-thumbdown': `url(${assetPrefix}/speedpro/thumb_down.png)`
        } as React.CSSProperties}>
        {children}
      </body>
      </>
    </LanguageProvider>
  );
}